function pad(num, size) { // add leading zeroes
    let s = "000000000" + num;

    return s.substr(s.length-size);
}

$('.countdown__timer').each(function () {
    let $timerElem = $(this),
        now = moment(),
        countdownTo = $(this).attr('data-countdown-to');

    if (typeof countdownTo === 'undefined') return false;

    countdownTo = moment(countdownTo, 'DD-MM-YYYY');

    if (countdownTo > now) {
        let timer = setInterval(function () {
            let now = moment(),
                timeRemaining = moment.duration(countdownTo.diff(now));

            let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24)),
                hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"
            $timerElem.text(pad(days, 2) + ":" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2));

            // If the countdown is finished, write some text
            if (timeRemaining < 0) {
                clearInterval(timer);
            }
        }, 1000);
    }
});
